import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserInfo } from '@/features/_data/useUserInfo';
import { AuthPage } from '@/features/AuthPage/AuthPage';
import { useCurrentAuthSession } from '@/context/AuthContext';

type Props = {
  readonly children: React.ReactNode;
  readonly admin?: boolean;
};

export const ProtectedRoute = ({ children, admin }: Props) => {
  const { isLoading, isLoggedIn } = useCurrentAuthSession();
  const { data: userInfo } = useUserInfo();
  const isAdmin = userInfo?.accessLevel === 90;
  const navigate = useNavigate();

  useEffect(() => {
    if (admin && !isAdmin) {
      navigate('/', { replace: true });
    }
  }, [navigate, admin, isAdmin]);

  if (isLoading) {
    return null;
  }

  if (!isLoggedIn) {
    return <AuthPage />;
  }

  return <>{children}</>;
};
